import { Injectable } from "@angular/core";
import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";

import { LoaderService } from '../service/loaderService';
import { Router } from "@angular/router";

// Per-request opt-out of the global center loader. A component sets this via
// `{ context: new HttpContext().set(SKIP_LOADER, true) }` on a request's options —
// used e.g. by LiveOrdersComponent so its background list/count polling (tab switch,
// pagination, 30s auto-refresh) doesn't keep flashing the loader after the initial load.
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    constructor(public loaderService: LoaderService, private router: Router) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.context.get(SKIP_LOADER)) {
            return next.handle(req);
        }

        // Skip loader for specific routes
        const skipLoaderRoutes = ['/reports/h3view', '/reports/cluster', '/settings/cluster', '/reports/basicorderreport', ''];
        const skipLoaderPatterns = ['/orders/orderdetail'];


        // Check exact matches
        if (skipLoaderRoutes.includes(this.router.url)) {
            return next.handle(req);
        }

        // Check pattern matches
        if (skipLoaderPatterns.some(pattern => this.router.url.startsWith(pattern))) {
            return next.handle(req);
        }
        // Skip loader for specific URLs
        if (req.url.includes('https://ragapi.adloggs.com/') || req.url.includes('http://192.168.0.216:4000/')||req.url.includes('/whatsapp/bot/status')) {
            return next.handle(req);
        }

        // Skip global loader for order list — infinite scroll uses its own inline loader
        if (req.url.includes('v110/order/list')) {
            return next.handle(req);
        }

        this.loaderService.show();
        return next.handle(req).pipe(
            finalize(() => this.loaderService.hide())
        );
    }
}